import React, {
	useEffect, useState
}from 'react'
import {
	Table, Pagination, Popconfirm
}from 'antd'
import {
	useDebounce
}from 'use-lodash-debounce'
import {
	reResponsibilityTypeActions
}from '../ReResponsibilityTypes/actions'
import {
	useDispatch,
	useSelector
}from 'react-redux'
import LoadingComponent from '../../../components/Loading/Local'
import {
	i18n
}from '../localization'
import i18nGlobal from '../../../localization'
import {
	CustomInput
}from '../../../components/CustomInput'
import CustomButton from '../../../components/ButtonCustom'
import ReResponsibilityTypeChangeForm from './ReResponsibilityTypeChangeForm'
import Notifications from '../../../helpers/Notifications'
import CRUDIcons from "../../../components/CRUDIcons/index"

const ReResponsibilityTypes = (props) => { //'Виды ответственности'
	const { isModify = false } = props
	const [countRespTypes, setCountRespTypes] = useState('')
	const [table, setTable] = useState([])
	const [page, setPage] = useState(0)
	const [allPaged, setAllPaged] = useState(false)
	const [visibleForm, setVisibleForm] = useState(false)
	const [changedValues, setChangedValues] = useState(null)
	const [value, setValue] = useState('')
	const searchValue = useDebounce(value, 500)
	const RespTypes = useSelector(state => state.reResponsibilityTypeReducer.currentItem)
	const { isSending, responsibilityTypeChanged } = useSelector(state => state.reResponsibilityTypeReducer)
	const dispatch = useDispatch()
	const isRu = useSelector(state => state.globalReducer.isRu)
	const pageSize = 10

	const getResponsibilityTypeByName = params => {
		dispatch(reResponsibilityTypeActions.getResponsibilityTypeByName(params))
	}

	const createResponsibilityType = params => {
		dispatch(reResponsibilityTypeActions.createResponsibilityType(params))
	}

	const deleteResponsibilityType = params => {
		dispatch(reResponsibilityTypeActions.deleteResponsibilityType(params))
	}

	const restoreResponsibilityType = params => {
		dispatch(reResponsibilityTypeActions.restoreResponsibilityType(params))
	}

	const updateResponsibilityType = params => {
		dispatch(reResponsibilityTypeActions.updateResponsibilityType(params))
	}

	useEffect(() => {
		return () => {
			dispatch(reResponsibilityTypeActions.clearResponsibilityType())
		}
	}, [])

	useEffect(() => {
		const items = RespTypes.items
		if (items){
			const temp = []
			items.forEach((value, index) => {
				temp.push({
					id        : value.id,
					code      : value.code,
					name      : value.name,
					nameBel   : value.nameBel,
					startDate : new Date(value.startDate).toLocaleDateString('ru-RU'),
					endDate   : value.endDate ? new Date(value.endDate).toLocaleDateString('ru-RU') : '',
					rowKey    : index,
					isDeleted : value.isDeleted
				})
			})
			setCountRespTypes(RespTypes.count)
			setTable(temp)
		}
	}, [RespTypes])

	useEffect(() => {
		setPage(1)
		const name = searchValue.trim().length > 2 ? searchValue.trim() : ''
		if (!name && !allPaged){
			getResponsibilityTypeByName({
				name     : name,
				pageSize : pageSize,
				page     : 1
			})
			setAllPaged(true)
		}
		if (name){
			getResponsibilityTypeByName({
				name     : name,
				pageSize : pageSize,
				page     : 1
			})
			setAllPaged(false)
		}
	}, [searchValue])

	useEffect(() => {
		if (responsibilityTypeChanged){
			Notifications.successNotice(responsibilityTypeChanged, '', 15)
			onPaginationChange(page)
		}
	}, [responsibilityTypeChanged])

	function onPaginationChange(value){
		setPage(value)
		getResponsibilityTypeByName({
			name     : searchValue.trim().length > 2 ? searchValue.trim() : '',
			pageSize : pageSize,
			page     : value
		})
	}

	const columns = [
		{
			title     : i18n.tableHeaderCode[isRu],
			inputType : 'text',
			dataIndex : 'code',
			editable  : false,
			key       : 'code',
			width     : 100
		},
		{
			title     : i18n.tableHeaderNameRu[isRu],
			inputType : 'text',
			dataIndex : 'name',
			editable  : false,
			key       : 'name'
		},
		{
			title     : i18n.tableHeaderNameBel[isRu],
			inputType : 'text',
			dataIndex : 'nameBel',
			editable  : false,
			key       : 'nameBel'
		},
		{
			title     : i18n.tableHeaderDateStart[isRu],
			inputType : 'text',
			dataIndex : 'startDate',
			editable  : false,
			key       : 'startDate'
		},
		{
			title     : i18n.tableHeaderDateEnd[isRu],
			inputType : 'text',
			dataIndex : 'endDate',
			editable  : false,
			key       : 'endDate'
		}
	]

	isModify ? columns.push({
		dataIndex : 'change',
		key       : 'update',
		width     : 100,
		render    : (id, record) => (
			<>
				<div>
					{CRUDIcons.update((e) => {
                        e.stopPropagation()
						setChangedValues(record)
						setVisibleForm(true)
                    })}
					<Popconfirm
						cancelText={ i18nGlobal.no[isRu] }
						okText={ i18nGlobal.yes[isRu] }
						title={ !record.isDeleted ? i18n.messageChooiseDeleteItem[isRu] : i18n.messageChooiseUpdateItem[isRu] }
						onCancel={ (e) => {
							e.stopPropagation()
							return null
						} }
						onConfirm={ (e) => {
							e.stopPropagation()
							!record.isDeleted ? deleteResponsibilityType({ id: record.id }) : restoreResponsibilityType({ id: record.id })
						} }
					>
						{!record.isDeleted 
                          ? CRUDIcons.delete((e) => e.stopPropagation()) 
                          : CRUDIcons.restore((e) => e.stopPropagation())}
					</Popconfirm>
				</div>
			</>
		)
	}) : null

	return (
		<>
			{ window.scrollTo(0, 0) }
			<div>
				<div className="header-admin-nsi">
					<CustomInput
						maxLength={ 64 }
						placeholder={ i18n.placeholderSearchInput[isRu] }
						onChange={ (e) => setValue(e.target.value) }
					/>
					{ isModify && (
						<CustomButton
							className="add-nsi"
							loading={ isSending }
							type="orange"
							onClick={ () => setVisibleForm(true) }
						>
							{CRUDIcons.create()}
							<span>
								{ i18n.buttonAdd[isRu] }
							</span>
						</CustomButton>
					 ) }
				</div>
				<>
					<Table
						columns={ columns }
						dataSource={ table }
						loading={ {
							indicator : <LoadingComponent />,
							spinning  : isSending
						} }
						pagination={ false }
						rowKey={ table => table.rowKey }
					/>
					{
						countRespTypes > pageSize && <Pagination
							current={ page }
							pageSize={ pageSize }
							showSizeChanger={ false }
							total={ countRespTypes }
							onChange={ onPaginationChange }
						                             />
					}
				</>
			</div>
			<ReResponsibilityTypeChangeForm
				create={ createResponsibilityType }
				resource={ changedValues }
				setResource={ setChangedValues }
				setVisible={ setVisibleForm }
				update={ updateResponsibilityType }
				visible={ visibleForm }
			/>
		</>
	)
}

export default ReResponsibilityTypes